export default __webpack_public_path__ + "static/media/DE-Logo-white.a6d28827.jpeg";